import { axiosPostRest } from "@Tools";
const fnMessage = (bootstraClass, message) => `<div class="alert alert-${bootstraClass} alert-dismissible fade show" role="alert">${message}<button type="button" class="btn-close close" data-dismiss="alert" aria-label="Close"></button></div>`;

// Shared email validator
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const validateEmail = (s) => emailRegex.test((s || '').trim());

// Cached selectors
const $doneReset = $('#done-reset');
const $txtReset = $('#txtreset');
const $frmLogin = $('#frmLogin');
const $doneLogin = $('#done-login');
const $btnReset = $('#btnreset');

const getMessage = (data, message) => message ?? (typeof data === 'string' ? data : (data?.message ?? 'An unexpected error occurred'));
const isSuccess = (status) => (typeof status === 'string') ? (status === 'success' || status === 'ok') : (typeof status === 'number' ? (status >= 200 && status < 300) : false);
const showMessage = ($el, type, text) => $el.html(fnMessage(type, text));

$(document).on("click", ".forgetPass", function (e) {
    e.preventDefault();
    $("#profileLogin").fadeOut(0, function () {
        $("#profileReset").fadeIn(0);
    });
});

$(document).on("click", ".forgetLogin", function (e) {
    e.preventDefault();
    $("#profileReset").fadeOut(0, function () {
        $("#profileLogin").fadeIn(0);
    });
});

$(document).on("click", "#btnreset", function (e) {
    e.preventDefault();

    // Validate email before sending
    const emailVal = ($txtReset.val() || '').trim();

    if (!emailVal) {
        showMessage($doneReset, 'danger', 'Please enter your email address.');
        $txtReset.focus();
        return;
    }

    if (!validateEmail(emailVal)) {
        showMessage($doneReset, 'danger', 'Please enter a valid email address.');
        $txtReset.focus();
        return;
    }

    const formData = new FormData(e.currentTarget.form);
    formData.append('_method', 'PUT');

    // prevent double-submit
    $btnReset.prop('disabled', true);

    axiosPostRest({
        endpoint: '/reset/password',
        data: formData,
        BMCallBack: (data, status, message) => {
            const text = getMessage(data, message);

            if (isSuccess(status)) {
                showMessage($doneReset, 'success', text);
            } else {
                showMessage($doneReset, 'danger', text);
            }

            $txtReset.val('');

            // re-enable button
            $btnReset.prop('disabled', false);
        }
    });
});

$(document).on('submit', '#frmLogin', function (e) {
    const $form = $frmLogin; // cached
    const email = ($form.find('input[name="username"]').val() || '').trim();
    const password = ($form.find('input[name="password"]').val() || '');

    if (!email) {
        e.preventDefault();
        showMessage($doneLogin, 'danger', 'Please enter your email address.');
        $form.find('input[name="username"]').focus();
        return false;
    }

    if (!validateEmail(email)) {
        e.preventDefault();
        showMessage($doneLogin, 'danger', 'Please enter a valid email address.');
        $form.find('input[name="username"]').focus();
        return false;
    }

    if (!password) {
        e.preventDefault();
        showMessage($doneLogin, 'danger', 'Please enter your password.');
        $form.find('input[name="password"]').focus();
        return false;
    }

    return true;
});


// Clear inline messages when the user starts typing
$frmLogin.on('input', 'input', function () {
    $doneLogin.html('');
});
